import React, { useEffect, useState } from "react";
import api from "~/services/api";
import CreateEditContent from "./CreateEditContent";
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import { Colors } from "~/config/Colors";
import {
  SLEditModal,
  SLCreateModal,
} from "~/pages/Sistema/componentes/SistemaList";
import { useSelector } from "react-redux";

export default function Orcamentos() {
  const [data, setData] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);
  const [clientes, setClientes] = useState([]);

  useEffect(() => {
    async function handleRequests() {
      api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } })
        .then(response => setClientes(response.data));
    }

    handleRequests();
  }, []);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-sc"
            requests={{
              findAll: () =>
                api.get('/signed/empresa/gestorprojeto/orcamentos'),
              findOne: thisData =>
                api.get('/signed/empresa/gestorprojeto/orcamento', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/empresa/gestorprojeto/orcamento', {
                  data: { id: thisData.id },
                }),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            topMain={false}
            informationPage={{
              title: "Orçamento",
              subTitle: "Crie e Gerencie seus orçamentos",
              icone: "menu-orcamentos",
              menu: true,
            }}
            tabFilter={{
              initial: { ativo: true },
              tabAtivo: 1,
              list: [
                {
                  corDestaque: localStorage.getItem("tema") == "E" ? '#9A3636' : '#e68282',
                  corFundo: Colors?.Color8,
                  title: 'Desativado',
                  value: { ativo: false },
                },
                {
                  corDestaque: Colors?.Color4,
                  corFundo: Colors?.Color8,
                  title: "Ativo",
                  value: { ativo: true },
                },
              ],
            }}
            selects={[
              {
                list: clientes,
                value: "id",
                label: "nomeFantasia",
                outLabel: "Todos os Clientes",
                filter: "idCliente",
              },
            ]}
            inputs={[
              { filter: "titulo", label: "Titulo" },
              { filter: "id", label: "Id" },
              { filter: "cliente.nomeFantasia", label: "Cliente" },
            ]}
          >
            <SLEditModal menu={true} title="Atualizar Orçamento" setter={setMountedData}>
              {mountedData && (
                <CreateEditContent {...{ mountedData }} />
              )}
            </SLEditModal>

            <SLCreateModal menu={true} title="Adicionar Orçamento">
              <CreateEditContent />
            </SLCreateModal>

            <CustomBodyContent {...{ data }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
